import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/icon/phone.png'
import _imports_1 from '../../../assets/icon/qq.png'
import _imports_2 from '../../../assets/image/m1_img1.png'


const _hoisted_1 = { class: "module1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "dialog-footer" }

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'module1',
  setup(__props) {

let dialogVisible = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"content\" data-v-3d287e15><h1 data-v-3d287e15>物业收费管理系统</h1><p data-v-3d287e15>适用于社区 园区 写字楼等</p><p data-v-3d287e15>以上百家成功案例经验，量身定制合理的开发方案</p><a href=\"tel:13509189441\" target=\"_self\" class=\"contact_link\" data-v-3d287e15><img src=\"" + _imports_0 + "\" data-v-3d287e15><span data-v-3d287e15>联系我们</span></a><a class=\"contact_link\" data-v-3d287e15><img src=\"" + _imports_1 + "\" data-v-3d287e15><span data-v-3d287e15>45286653</span></a></div>", 1)),
      _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : dialogVisible = $event)),
        title: "联系我们"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialogVisible) //@ts-ignore
 ? dialogVisible.value = false : dialogVisible = false))
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" 确定 ")
              ])),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "contact" }, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, "联系人：韩经理")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", null, "联系电话："),
              _createElementVNode("a", {
                href: "tel:13509189441",
                target: "_self"
              }, "13509189441")
            ])
          ], -1))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "image-container" }, [
        _createElementVNode("img", {
          src: _imports_2,
          alt: "示例图"
        })
      ], -1))
    ])
  ]))
}
}

})